import { useEffect, useRef } from "react";
const NADA = { pagina() { }, evento() { }, consentir() { }, ligada: false };
/** Liga o GA4 uma vez por página. Chamadas seguintes devolvem a mesma medição. */
export function iniciarMedicao(o) {
    const id = o.id?.trim();
    const w = (o.janela ?? (typeof window !== "undefined" ? window : undefined));
    if (!id || !w)
        return NADA;
    if (w.__weMedicao)
        return w.__weMedicao;
    w.dataLayer = w.dataLayer || [];
    // O gtag do Google lê os argumentos como estão (`arguments`): por isso o push do objeto de argumentos.
    const gtag = function () {
        // eslint-disable-next-line prefer-rest-params
        w.dataLayer.push(arguments);
    };
    w.gtag = gtag;
    gtag("consent", "default", {
        analytics_storage: o.consentimento,
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
    });
    gtag("js", new Date());
    gtag("config", id, { send_page_view: false });
    if (o.carregarScript !== false && typeof document !== "undefined") {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
        document.head.appendChild(s);
    }
    const medicao = {
        ligada: true,
        pagina(caminho) {
            gtag("event", "page_view", {
                page_location: new URL(caminho, w.location.origin).toString(),
                page_title: w.document?.title ?? "",
                app_id: o.app,
            });
        },
        evento(nome, params) {
            gtag("event", nome, { ...params, app_id: o.app });
        },
        consentir(c) {
            gtag("consent", "update", { analytics_storage: c });
        },
    };
    w.__weMedicao = medicao;
    return medicao;
}
/**
 * Um `page_view` por navegação: `chave` é a da navegação (no React Router, `location.key`), que muda a cada
 * entrada no histórico, inclusive ao voltar, e não muda quando o React roda o efeito de novo.
 */
export function contadorDePaginas(medicao) {
    let ultima = null;
    return (chave, caminho) => {
        if (ultima === chave)
            return false;
        ultima = chave;
        medicao.pagina(caminho);
        return true;
    };
}
/** `pronto`: espere o que muda o consentimento (o login) antes de contar a primeira página. */
export function usePaginaVista(medicao, chave, caminho, pronto = true) {
    const contar = useRef(null);
    contar.current ??= contadorDePaginas(medicao);
    useEffect(() => {
        if (pronto)
            contar.current(chave, caminho);
    }, [chave, caminho, pronto]);
}
